import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = (theme) =>
    makeStyles(() => ({
        tabsContainer: {
            borderBottomWidth: 1,
            borderStyle: "solid",
            // overflow: "unset !important",

            // "& > div": {
            //     overflow: "unset !important",
            // },
        },

        primaryTabsVariant: {
            borderColor: theme.tabs.primary.borderColor,
        },

        tab: {
            textTransform: "capitalize",
            minWidth: "88px",
            fontFamily: theme.tab.common.fontFamily,
            fontSize: theme.tab.common.fontSize,
            fontWeight: theme.tab.common.fontWeight,
            opacity: 1,

            // "&:focus": {
            //     position: "relative",
            //     zIndex: 1,
            //     borderRadius: theme.tab.common.borderRadius,
            //     outline: theme.tab.common.focus.outline,
            //     outlineOffset: theme.tab.common.focus.outlineOffset,
            // },
        },

        primaryTabVariant: {
            color: theme.tab.primary.color,
            backgroundColor: theme.tab.primary.backgroundColor,

            "&:hover": {
                backgroundColor: theme.tab.primary.hover.backgroundColor,
            },

            "&.Mui-selected": {
                fontWeight: theme.tab.primary.selected.fontWeight,
            },

            "&:disabled": {
                color: theme.tab.primary.disabled.color,
            },
        },
    }))();
